<template>
  <div class="bills-detail-card-box">
      <div class="goods-card">
          <div class="title">
              <div class="title-shop">
                  <!-- <img :src="logoUrl" alt="" width="20" height="20" v-if="logoUrl.length > 0">
                  <img src="../../assets/images/store.png" alt="" width="20" height="20" v-else>
                  <span>{{ orderInfo.shop }}</span> -->
                  <span class="oid">订单号 {{ orderInfo.oid }}</span>
                  <img src="../../assets/images/copy.png" alt="" width="16" height="16" @click="copyToClipboard(orderInfo.oid)">
              </div>
              <span class="status-cancel" >{{ orderInfo.createAt.split(' ')[0] }}</span>
          </div>
          <div class="goods-desc" v-for="(list, index) in orderInfo.lists" :key="index">
              <div class="img">
                  <img :src="list.imgUrl" alt="" width="75" height="75">
              </div>
              <div class="card-right">
                  <div class="desc-text">{{ list.title }}</div>
                  <div class="type-text">{{ list.type }}</div>
                  <div class="price">
                      <div><span>￥</span>{{ list.price }}</div>
                      <div style="color:#969699;font-size: 14px;">共{{ list.amount }}个</div>
                  </div>
              </div>
          </div>
          <div class="price-row" v-if="orderInfo.status !== 'orderRefund' && orderInfo.status !== 'orderPaidCancel' && !showDetails">
              <div class="amount">共{{ orderInfo.lists.length }}款</div>
              <div class="price">
                  <span><span class="amount">{{ this.text }}</span> ￥{{ orderInfo.finalPayPrice }}</span>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import {Toast} from 'vant'

export default {
name: 'BillsDetailCard',
components: {
},
created(){
    if(this.$route.query.tabId){
        if(this.$route.query.tabId === '0'){
            this.text = '未月结'
        } else if(this.$route.query.tabId === '1') {
            this.text = '已月结'
        }
    }
},
mounted(){
},
updated(){
},
data:()=>{
  return {
    text:'月结'
  }
},
methods:{
  pay(){
      this.$emit('pay', this.orderInfo.oid)
  },
  // 复制到剪切板
  copyToClipboard(text) {
    const textarea = document.createElement("textarea"); // 创建一个textarea元素
    textarea.value = text; // 设置textarea的值
    document.body.appendChild(textarea); // 将textarea添加到DOM中
    textarea.select(); // 选中textarea中的文本
    document.execCommand("copy"); // 将选中的文本复制到剪贴板中
    document.body.removeChild(textarea); // 从DOM中移除textarea
    Toast('已复制');
  },
},
props:{
  orderInfo:{
      type: Object,
      default: ()=>{}
  },
  showButton:{
      type: Boolean,
      default: true
  },
  showDetails:{
      type: Boolean,
      default: false
  },
  tabId:{
      type: String,
      default: '0'
  },
  logoUrl:{
      type: String,
      default: ''
  }
}
}
</script>

<style scoped lang="scss">
.bills-detail-card-box {
  .goods-card {
      background: #fff;
      margin: 10px;
      border-radius: 20px;
      .title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 15px;
          font-size: 15px;
          .title-shop {
              display: flex;
              align-items: center;
              img {
                  border-radius: 2px;
                  margin: 0 5px;
              }
              .oid {
                color: #969699;
              }
          }
          .count-down {
              display: flex;
              align-items: baseline;
              span {
                  margin-left: 5px;
              }
          }
          .status-paying {
              font-size: 15px;
              color: #f0061d;
          }
          .status-picking {
              font-size: 15px;
              color: #ffd700;
          }
          .status-cancel {
              font-size: 15px;
              color: #969699
          }
      }
      .express-info {
          display: flex;
          background: #f3f3f3;
          padding: 5px 0;
          margin: 0 15px 20px;
          font-size: 14px;
          border-radius: 5px;
          text-align: left;
          .title {
              padding: 0 10px 0 10px;
          }
      }
      .express-info-picking {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f3f3f3;
          padding: 5px 10px;
          margin: 0 15px 20px;
          font-size: 14px;
          border-radius: 5px;
          .title {
              padding: 0;
          }
      }
      .goods-desc {
          display: flex;
          position : relative;
          padding: 0 10px 0px;
          .img {
              width: 110px;
          }
          img {
              border-radius: 2px;
          }
          .card-right {
              flex: 1;
              padding: 0 0px 0 10px;
              text-align: left;
              word-break: break-all;
              .desc-text {
                  font-size: 17px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
              }
              .type-text {
                  font-size: 15px;
                  margin: 5px 0;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
              }
              .price {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  font-size: 18px;
                  // font-weight: 600;
                  padding: 5px 15px 0px 0;
                  span {
                      font-size: 16px;
                  }
              }
          }
      }
      .show-details {
          text-align: left;
          margin: 0 15px;
          font-size: 15px;
          .ticket {
              border-top: 1px rgba(0,0,0,0.05) solid;
              border-bottom: 1px rgba(0,0,0,0.05) solid;
              margin: 10px 0;
              padding: 10px 5px;
              .ticket-text {
                  padding: 5px 0;
                  color: #969699;
              }
          }
          .price {
              .total-price {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 5px 5px;
              }
              .discount-price {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 5px 5px;
              }
              .express-charge {
                  display: flex;
                  justify-content: space-between;
                  padding: 0 5px 15px;
              }
              .call-owner {
                  display: flex;
                  justify-content: center;
                  border-top: 1px rgba(0,0,0,0.1) solid;
                  padding: 15px 0;
                  .divider {
                      padding: 0 10px;
                  }
              }
          }
      }
      .price-row {
          display: flex;
          justify-content: space-between;
          margin: 15px 15px 0;
          padding: 10px 0 15px;
          border-top: 1px rgba(0,0,0,0.05) solid;
          .amount {
              font-size: 15px;
              min-width: fit-content;
              color: #969699;
          }
          .price {
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-end;
              span {
                  padding: 0 5px;
                  font-size: 15px;
              }
              .price-grey {
                  color: #969699;
              }
          }
      }
      .button-group {
          margin: 0 10px;
          display: flex;
          justify-content: flex-end;
          padding-bottom: 5px;
          .button {
              border: 1px rgba(0,0,0,0.2) solid;
              border-radius: 25px;
              padding: 0 15px;
              font-size: 15px;
              margin: 5px 10px;
              height: 30px;
              line-height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
          }
          .button-pay {
              // border: 1px rgba(0,0,0,0.01) solid;
              // background: #fc5f10;
              background: #29323c;
              border: 1px solid #29323c;
              border-radius: 25px;
              padding: 0 20px;
              font-size: 15px;
              height: 30px;
              line-height: 30px;
              margin: 5px 10px;
              color: #fff;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;
          }
      }
  }
  .show-details-pay {
      text-align: left;
      background: #fff;
      margin: 10px;
      border-radius: 15px;
      padding: 10px 20px;
      font-size: 15px;
      .final-pay-price {
          display: flex;
          padding: 0 0 10px;
          margin: 5px 0 0;
          border-bottom: 1px rgba(0,0,0,0.1) solid;
      }
      .pay-desc {
          padding: 5px 0 0;
          margin: 0 0 5px;
          .row {
              padding: 5px 0;
          }
      }
  }
}
::v-deep .van-count-down {
  color: #f0061d;
  font-size: 15px;
  line-height: 20px;
}
</style>